export class ApiResultado<T>  {

    Count: number;
    Data: T[];
    Now: string;

}